import React, { Suspense, lazy, useEffect } from "react";
import { useSelector } from "react-redux";
import { MemoryRouter as Router } from "react-router-dom";
import EmptyParams from "./EmptyParams";
import RutaTematica from "./RutaTematica";
import Cargando from "./Cargando";
const LayoutD = lazy(() => import("../components/Layouts/LayoutD"));

const renderLayout = (lay) => {
  switch (lay) {
    default:
      return <LayoutD />;
  }
};

const App = () => {
  const isLoading = useSelector((state) => state.config.isLoading);
  const lay = useSelector((state) => state.config.ui);
  const emptyParams = useSelector((state) => state.error.emptyParams);

  return emptyParams ? (
    <EmptyParams />
  ) : isLoading ? (
    <Cargando />
  ) : (
    <Router>
      <Suspense fallback={<Cargando />}>{renderLayout(lay)}</Suspense>
    </Router>
  );
};

export default App;
